document.addEventListener('DOMContentLoaded', function () {
    const isMobile = window.innerWidth < 750; // Mobil kontrolü

    if (isMobile) {
        // Başlangıçta tüm overlay'ler gizlenir
        document.querySelectorAll('.quick-buy-overlay').forEach(overlay => {
            overlay.classList.remove('open'); 
        });

        // + butonuna tıklanarak sadece ilgili overlay görünür hale gelir
        document.querySelectorAll('.toggle-sizes-btn').forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();

                const productItem = button.closest('.product-item');
                const overlay = productItem.querySelector('.quick-buy-overlay');

                if (!overlay) return;

                const isOpen = overlay.classList.contains('open');

                // Tüm overlay'leri gizle ve butonları sıfırla
                document.querySelectorAll('.quick-buy-overlay').forEach(o => o.classList.remove('open'));
                document.querySelectorAll('.toggle-sizes-btn').forEach(b => b.textContent = '+');

                if (!isOpen) {
                    overlay.classList.add('open'); // İlgili overlay'i aç
                    button.textContent = '−'; // Butonun içeriğini eksi yap
                }
            });
        });
    }
});


function addToCart(button) {
    event.preventDefault();

    // Eğer buton "Stoklar Tükendi" durumundaysa ekleme yapılmaz
    if (button.classList.contains('out-of-stock')) {
        return;
    }

    // Seçilen bedeni bul
    const selectedSize = button.closest('.quick-buy-overlay').querySelector('.size-option.selected');
    if (!selectedSize) {
        return;
    }

    // Seçilen beden stokta mı kontrol et
    const isAvailable = selectedSize.getAttribute('data-available') === "true";
    if (!isAvailable) {
        button.innerText = "Stoklar Tükendi";
        button.disabled = true;
        setTimeout(() => {
            button.innerText = "Sepete Ekle";
            button.disabled = false;
        }, 2000);
        return;
    }

    // Seçilen bedenin değeri
    const selectedSizeValue = selectedSize.getAttribute('data-option');

    // Varyantları JSON'dan al
    const variantData = JSON.parse(button.closest('.product-item').querySelector('.product-variants').textContent);

    // Seçilen beden değeri ile eşleşen varyantı bul
    const variant = variantData.find(v => v.option2 === selectedSizeValue);

    if (!variant) {
        return;
    }

    const variantId = variant.id;

    // Sepete ekleme işlemi
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(response => response.json())
    .then(data => {
        // Ürün başarıyla sepete eklendiğinde drawer'ı aç ve içerikteki ürün güncellenmesini tetikle
        document.dispatchEvent(new CustomEvent('theme:product:added'));

        const cartDrawer = document.querySelector('cart-items');

        
        if (cartDrawer) {
           cartDrawer.getCart();
        }
    })
    .catch(error => {
        console.error("Sepete eklenirken hata oluştu:", error);
    });
}

// Beden seçimi için olay dinleyici
document.querySelectorAll('.size-option').forEach(button => {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        const isAvailable = button.getAttribute('data-available') === "true";

        // Sepete Ekle butonunu ayarla
        const addToBagButton = button.closest('.quick-buy-overlay').querySelector('.add-to-bag-btn');
        
        if (!isAvailable) {
            addToBagButton.innerText = "SOLD OUT";
            addToBagButton.classList.add('out-of-stock');
            addToBagButton.disabled = true;
        } else {
            addToBagButton.innerText = "ADD TO CART";
            addToBagButton.classList.remove('out-of-stock');
            addToBagButton.disabled = false;
        }

        // Tüm diğer bedenlerden 'selected' sınıfını kaldır
        button.closest('.quick-buy-sizes').querySelectorAll('.size-option').forEach(btn => btn.classList.remove('selected'));
        button.classList.add('selected');
    });
});
